import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { GlobalConstants } from '../../../../../../../src/app/common/constants/global.constant';
import { Subject } from 'rxjs/internal/Subject';
import { environment } from '../../../../../../environments/environment';
import { OemConstants } from '../../../../../../../src/app/core/routing/services/oem/constants/oem.constants';
import { AssetLibraryConstants } from '../../../../../../../src/app/core/routing/services/asset-library/constants/asset-library.constant';

@Component({
  selector: 'iposcen-pages-view',
  templateUrl: './pages-view.component.html',
  styleUrls: ['./pages-view.component.scss']
})
export class PagesViewComponent implements OnInit {
  @Input() configData: any;
  @Input() autoID: string;
  multiPageconfig: any;
  contentData: any;
  configurations: any;
  singlePageConfig: any;
  videoPageConfig: any;
  bodyLabel = GlobalConstants.PAGES_VIEW_BODY;
  bodyHeading = GlobalConstants.PAGES_VIEW_HEADING_CAPS; 
  bodyLabelB = GlobalConstants.PAGES_VIEW_BODY_B;
  bodyLabelA = GlobalConstants.PAGES_VIEW_BODY_A;
  headingLabel = GlobalConstants.PAGES_VIEW_HEADING
  imageUrl: string;
  logoUrl: string;
  imageAUrl: string;
  imageBUrl: string;
  heroImageUrl: string;
  videoUrl: string;
  title: string;
  imageTitle: string;
  videoTitle: string;
  body: string;
  bodyA: string;
  bodySize: string;
  bodyASize: string;
  bodyB: string;
  isOpen: number | null = null;
  bodyBSize: string;
  url = OemConstants.SKU_COMMON + AssetLibraryConstants.SLASH;
  commonUrl:string;
  commonUrlVideo:string;
  hotSpotLen:number;
  accordianItems = [];
  isModalOpen = [];
  currentPageModalOpen : number;
  hotSpotPopUpUrl:string;
  hotSpotAssetType:string;
  private ngUnsubscribe = new Subject<boolean>();
  constructor() { }
  ngOnInit(): void {
    this.contentData = this.configData[0];
    this.commonUrl = environment.apiBaseUrlAsset + this.url + this.autoID + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH;
    this.commonUrlVideo = environment.apiBaseUrlAsset + this.url + this.autoID + OemConstants.SLASH_ASSETS + OemConstants.SLASH_VIDEO + AssetLibraryConstants.SLASH;
    this.contentData.forEach(ele => {
      if (ele.content.length > 0) {
        ele.content.forEach(element => {
          if (ele.uiLayout === '3-asset-layout') {
            if (element.alignment === 'leftTop') {
              this.imageAUrl = this.commonUrl + element.assetID;
              this.bodyA = element.subTitle;
              this.bodyASize = element.fontSize;
            } 
            if (element.alignment === 'leftBottom') {
              this.imageBUrl = environment.apiBaseUrlAsset + this.url + this.autoID + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID;
              this.bodyB = element.subTitle;
              this.bodyBSize = element.fontSize;
            } 
            if (element.alignment === 'right') {
              this.heroImageUrl = environment.apiBaseUrlAsset + this.url + this.autoID + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID;
              this.title = element.title;
              this.bodyBSize = element.fontSize;
            }
          } else if (ele.uiLayout === '1-image-layout' && element.alignment === 'i-center') {
            this.imageUrl = environment.apiBaseUrlAsset + this.url + this.autoID + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + element.assetID;
            this.imageTitle = element.title;
            this.body = element.subTitle
            this.bodySize = element.fontSize;
          } else {
            this.videoUrl = this.commonUrlVideo + element.assetID;
            this.videoTitle = element.title;
            if(Object.keys(ele?.hotspots).length)
             this.hotSpotLen=Object.keys(ele?.hotspots).length;
          }
        });
      }
      this.isModalOpen.push(false);
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

  }

  fontSize(size) {
    if (size == 12) {
      return GlobalConstants.FONTSIZE_12PX;
    }
    if (size == 14) {
      return GlobalConstants.FONTSIZE_14PX;
    }
    if (size == 16) {
      return GlobalConstants.FONTSIZE_16PX;
    }
  }

  setLogoURL(logoID) {
    const url = (logoID) ? environment.apiBaseUrlAsset + this.url + this.autoID + OemConstants.SLASH_ASSETS + OemConstants.SLASH_LOGO + AssetLibraryConstants.SLASH + logoID : '';
    return url;
  }

  setImageURL(imageID) {
    const url = (imageID) ? environment.apiBaseUrlAsset + this.url + this.autoID + OemConstants.SLASH_ASSETS + OemConstants.SLASH_IMAGE + AssetLibraryConstants.SLASH + imageID : '';
    return url;
  }

  getUILayoutIDByName(name) {// TODO - Confirm with Sujay if layout name is correct
    if (name === '3-asset-layout') {
      return 1;
    } else if (name === '1-image-layout') {
      return 2;
    } else if (name === '1-video-layout') {
      return 3;
    } else if (name === '1-hotspot-layout') {
      return 4;      
    }
  }

  toggleAccordion(index: number,url?:string,type?:string) {
    if(this.isOpen === index){return false;}
    this.isOpen = this.isOpen === index ? null : index;
    this.hotSpotPopUpUrl= url;
    this.hotSpotAssetType = type;
  }

  openModal(url?:string,type?:string,page?:number) {
    this.toggleAccordion(1,url,type);
    this.currentPageModalOpen=page;
    this.isModalOpen.splice(page-1,1,true);
  }

  closeModal() {
    this.isOpen=null; 
    this.isModalOpen.splice(this.currentPageModalOpen-1,1,false);
    }
}
